exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".header[data-v-bee722b0]{margin-bottom:48px}.btn-save-powerpage[data-v-bee722b0]{transition:opacity .2s ease-out;opacity:1}.btn-save-powerpage.saving[data-v-bee722b0]{opacity:.7;cursor:progress}", ""]);

// exports
